import { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { usePageTitle } from '@/hooks/usePageTitle';
import { useReleaseNoteStore } from '../store';
import { ReleaseNotesList } from '../components';
import { ListSkeleton } from '@/components/ui/skeleton';

export function ReleaseNotesPage() {
  usePageTitle("What's New");

  const {
    publishedReleases,
    isLoadingPublished,
    publishedError,
    fetchPublishedReleaseDetails,
  } = useReleaseNoteStore();

  useEffect(() => {
    fetchPublishedReleaseDetails();
  }, [fetchPublishedReleaseDetails]);

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-warning" />
          <h1 className="text-2xl font-bold tracking-tight">What's New</h1>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Latest updates and improvements across all platforms.
        </p>
      </div>

      {isLoadingPublished ? (
        <ListSkeleton rows={4} />
      ) : publishedError ? (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
          <p className="text-destructive">{publishedError}</p>
          <button
            onClick={() => fetchPublishedReleaseDetails()}
            className="text-sm text-primary hover:underline"
          >
            Try again
          </button>
        </div>
      ) : (
        <ReleaseNotesList releases={publishedReleases} />
      )}
    </div>
  );
}
